
function Header (){
    return (
        <header className="App-header">
            <h1>Make your video responsive</h1>
        </header>
    )
}

export default Header